import script from "./MultiPatientBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiPatientBar.vue?vue&type=script&setup=true&lang=js"

import "./MultiPatientBar.vue?vue&type=style&index=0&id=7b4be41c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b4be41c"]])

export default __exports__